import { render } from "./ElementProperties.vue?vue&type=template&id=f915efea"
import script from "./ElementProperties.vue?vue&type=script&lang=js"
export * from "./ElementProperties.vue?vue&type=script&lang=js"

import "./ElementProperties.vue?vue&type=style&index=0&id=f915efea&lang=scss"
script.render = render

export default script